import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CustomStore } from 'devextreme-angular/common/data';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private baseUrl = environment.apiUrl;

  
  historyStore = new CustomStore({
    key: 'host',
    load: (loadOptions: any) => {

      const page = loadOptions.skip / loadOptions.take + 1 || 1;
      const pageSize = loadOptions.take || 10;

      // Handle sorting
      let orderingParam = '';
      let sortParams = '';
      if (loadOptions.sort && loadOptions.sort.length > 0) {
        const sortField = loadOptions.sort[0].selector;
        const sortOrder = loadOptions.sort[0].desc ? 'desc' : 'asc';
        sortParams = `&sort_by=${sortField}&sort_order=${sortOrder}`;
      }

      const url = `${this.baseUrl}/api/history/?page_size=${pageSize}&page=${page}${sortParams}`;
      console.log('Loading data for history store, URL:', url);
      return firstValueFrom(this.http.get(url, {withCredentials: true})).then((response: any) => {
        return {
          data: response.results,
          totalCount: response.count
        };
      });
    }
  });

  constructor(private http: HttpClient) {}

  // Method to create a host-specific CustomStore
  createHostDetailStore(hostname: string): CustomStore {
    return new CustomStore({
      key: 'host_name',
      load: (loadOptions: any) => {

        const page = loadOptions.skip / loadOptions.take + 1 || 1;
        const pageSize = loadOptions.take || 10;

        const url = `${this.baseUrl}/api/history/${hostname}/?page_size=${pageSize}&page=${page}`;
        console.log('Loading data for hostname:', hostname, 'URL:', url);
        return firstValueFrom(this.http.get(url, {withCredentials: true})).then((response: any) => {
          // Extract the results array from the paginated response
          return {
            data: response.results,
            totalCount: response.count
          };
        });
      }
    });
  }





}